<template>
    <div class="bg-white border rounded-2xl dark:bg-neutral-900 dark:border-neutral-700">
        <div class="overflow-hidden border-b rounded-t-2xl dark:border-neutral-700 flex">
            <Tabs v-model:value="tab">
                <TabList>
                    <Tab value="email">
                        <div class="flex items-center gap-2 text-inherit">
                            <i class="pi pi-envelope"/>
                            <span>Email</span>
                        </div>
                    </Tab>
                    <Tab value="sms">
                        <div class="flex items-center gap-2 text-inherit">
                            <i class="pi pi-mobile"/>
                            <span>SMS</span>
                        </div>
                    </Tab>
                </TabList>
            </Tabs>
            <div class="grow"></div>
            <Button size="small" class="m-2.5 max-md:!hidden mr-0" @click="save" icon="pi pi-save" severity="secondary" :label="$t('common.save')"></Button>
            <Button size="small" class="m-2.5" @click="save(true)" icon="pi pi-save" :label="$t('forms.save_and_close')"></Button>
        </div>

        <div v-show="tab === 'email'" class="flex min-w-96 max-2xl:flex-col">
            <email-template-preview :template="template">
                <template #text-1>
                    <div id="text1"></div>
                </template>
            </email-template-preview>
            <div
                class="flex flex-col gap-4 mb-4 max-2xl:border-t 2xl:border-l divide-y bg-white dark:bg-transparent dark:text-white dark:border-neutral-700 divide-dashed dark:divide-neutral-700 overflow-hidden">
                <div class="flex flex-col gap-2 p-4 pb-0">
                    <label for="email_subject" class="text-sm font-semibold opacity-80">{{ $t('reservations.email_subject_label') }}</label>
                    <InputText id="email_subject" v-model="model.email_subject" :invalid="$page.props.errors.email_subject"/>
                    <small class="text-red-500" v-if="$page.props.errors.email_subject">{{
                            $page.props.errors.email_subject
                        }}</small>
                </div>
                <div class="flex flex-col gap-2 min-w-72 p-4 pb-0">
                    <label for="email_subject" class="text-sm font-semibold opacity-80">{{ $t('reservations.notification_state_label') }}</label>
                    <ToggleButton id="state" v-model="model.state" :onLabel="$t('reservations.notify_send_email')" :offLabel="$t('reservations.notify_not_send')"
                                  onIcon="pi pi-envelope"
                                  offIcon="pi pi-ban" :invalid="$page.props.errors.state"/>
                    <small class="text-red-500" v-if="$page.props.errors.state">{{ $page.props.errors.state }}</small>
                </div>
                <div class="flex flex-col gap-2 p-4 pb-0">
                    <label for="templates" class="text-sm font-semibold opacity-80">{{ $t('reservations.email_appearance_label') }}</label>
                    <email-template-picker v-model="template" :templates="templates" :text="model.text_2"></email-template-picker>
                </div>
            </div>
        </div>
        <div v-show="tab === 'sms'" class="flex max-md:flex-col">
            <div class="p-7 bg-neutral-200 dark:!bg-gray-800 flex justify-center grow">
                <s-m-s-template-preview :template="template" :sms-length="model.sms_text_2?.length" :max-length="200">
                    <template #text-1>
                        <div id="sms1"></div>
                    </template>
                </s-m-s-template-preview>
            </div>
            <div
                class="flex flex-col gap-4 min-w-72 mb-4 max-md:border-t md:border-l divide-y bg-white dark:bg-transparent dark:text-white dark:border-neutral-700 divide-dashed overflow-hidden">
                <div class="flex flex-col gap-2 p-4 pb-0">
                    <label for="email_subject" class="text-sm font-semibold opacity-80">{{ $t('reservations.notification_state_label') }}</label>
                    <ToggleButton id="state" v-model="model.state_sms" :onLabel="$t('reservations.notify_send_sms')" :offLabel="$t('reservations.notify_not_send')"
                                  onIcon="pi pi-mobile"
                                  offIcon="pi pi-ban" :invalid="$page.props.errors.state"/>
                    <small class="text-red-500" v-if="$page.props.errors.state">{{ $page.props.errors.state }}</small>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {Tabs, TabList, Tab, Button} from "primevue";
import DetailEditorLayout from '../../components/view-components/DetailEditorLayout.vue';
import EmailTemplatePreview from "../../components/ui-components/EmailTemplatePreview.vue";
import {onMounted, ref, toRef} from "vue";
import InputText from "primevue/inputtext";
import ToggleButton from "primevue/togglebutton";
import EmailTemplatePicker from "../../components/ui-components/EmailTemplatePicker.vue";
import {router, usePage} from "@inertiajs/vue3";
import "highlight.js";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import "quill-mention/dist/quill.mention.css"
import {Mention, MentionBlot} from "quill-mention";
import {getPrettyHTML} from "../../../../helpers.js";
import { trans } from 'laravel-vue-i18n';
import SMSTemplatePreview from "../../components/ui-components/SMSTemplatePreview.vue";

const props = defineProps({
    message: Object,
    id: Number,
    templates: Array,
    replace: Array,
    title: String
})
const tab = ref('email');
const template = ref(props.templates.find(el => el.id === props.message.id_email_templates));
const model = toRef(props, 'message');

let quill_email = null;
let quill_sms = null;
let AlignStyle = Quill.import('attributors/style/align')
let BackgroundStyle = Quill.import('attributors/style/background')
let ColorStyle = Quill.import('attributors/style/color')
let DirectionStyle = Quill.import('attributors/style/direction')
let FontStyle = Quill.import('attributors/style/font')
let SizeStyle = Quill.import('attributors/style/size')

Quill.register({"blots/mention": MentionBlot, "modules/mention": Mention});
Quill.register(AlignStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(DirectionStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

onMounted(() => {
    const replace = props.replace;

    quill_email = new Quill('#text1', {
        theme: 'snow',
        placeholder: 'Popisek emailu',
        modules: {
            toolbar: [
                [{'font': []}, {'size': []}],
                ['bold', 'italic', 'underline', 'strike'],
                [{'color': []}, {'background': []}],
                [{'script': 'super'}, {'script': 'sub'}],
                [{'header': '1'}, {'header': '2'}, 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['direction', {'align': []}],
                ['link', 'image', 'video', 'formula'],
                ['clean']
            ],
            mention: {
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                mentionDenotationChars: ["%"],
                source: function (searchTerm, renderList) {
                    if (searchTerm.length === 0) {
                        renderList(replace, searchTerm);
                    } else {
                        const matches = [];
                        for (let i = 0; i < replace.length; i++)
                            if (
                                ~replace[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                            )
                                matches.push(replace[i]);
                        renderList(matches, searchTerm);
                    }
                }
            }
        }
    });
    quill_email.setContents(JSON.parse(model.value.text_1))
    model.value.text_2 = getPrettyHTML(quill_email.container.firstChild.innerHTML);
    quill_email.on('text-change', () => {
        model.value.text_1 = JSON.stringify(quill_email.getContents());
        model.value.text_2 = getPrettyHTML(quill_email.container.firstChild.innerHTML);
    });



    quill_sms = new Quill('#sms1', {
        theme: 'snow',
        placeholder: trans('reservations.sms_message_placeholder'),
        modules: {
            toolbar: false,
            mention: {
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                mentionDenotationChars: ["%"],
                source: function (searchTerm, renderList) {
                    if (searchTerm.length === 0) {
                        renderList(replace, searchTerm);
                    } else {
                        const matches = [];
                        for (let i = 0; i < replace.length; i++)
                            if (
                                ~replace[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                            )
                                matches.push(replace[i]);
                        renderList(matches, searchTerm);
                    }
                }
            }
        }
    });
    quill_sms.setContents(JSON.parse(model.value.sms_text_1))
    model.value.sms_text_2 = getPrettyHTML(quill_sms.container.firstChild.innerHTML);
    quill_sms.on('text-change', () => {
        quill_sms.formatText(200, 5000, {
            'color': 'rgb(220, 20, 60)'
        });
        model.value.sms_text_1 = JSON.stringify(quill_sms.getContents());
        model.value.sms_text_2 = getPrettyHTML(quill_sms.container.firstChild.innerHTML).replace(/<[^>]*>/g, '');
    });
})

const save = (goBack = false) => {
    let m = model.value;
    m.id_email_templates = template.value.id;
    if (goBack) {
        m.go_back = goBack;
    }
    router.visit(`/app/notifications/${props.id}`, {
        method: 'post',
        data: m
    });
}
</script>
<style scoped>
</style>
